import { useContext } from 'react'
import ConfigurationContext from '../context/Configuration'

const ConfigurableValues = () => {
  const configuration = useContext(ConfigurationContext)
  console.log('configuration', configuration)
  // const SERVER_URL = 'https://borkuapi-test.up.railway.app'
  // const WS_SERVER_URL = 'wss://borkuapi-test.up.railway.app'

  // const WS_SERVER_URL = 'wss://borkuapi-test.up.railway.app'
  // const SERVER_URL = 'https://borkuapi-test.up.railway.app'

  const SERVER_URL = 'https://borku.up.railway.app'
  const WS_SERVER_URL = 'wss://borku.up.railway.app'

  // const SERVER_URL = 'https://borku1.up.railway.app/graphql'
  // const WS_SERVER_URL = 'wss://borku1.up.railway.app/graphql'

  // const SERVER_URL = 'https://5k2n1mch-8001.inc1.devtunnels.ms'
  // const WS_SERVER_URL = 'wss://5k2n1mch-8001.inc1.devtunnels.ms'

  // const SERVER_URL = 'https://p9pdddt3-8001.inc1.devtunnels.ms'
  // const WS_SERVER_URL = 'wss://p9pdddt3-8001.inc1.devtunnels.ms'
  // const SERVER_URL = 'http://192.168.18.72:8001'
  // const WS_SERVER_URL = 'wss://192.168.18.72:8001'

  const GOOGLE_MAPS_KEY = configuration.googleApiKey
  const FIREBASE_KEY = configuration.firebaseKey
  const APP_ID = configuration.appId
  const AUTH_DOMAIN = configuration.authDomain
  const STORAGE_BUCKET = configuration.storageBucket
  const MSG_SENDER_ID = configuration.msgSenderId
  const MEASUREMENT_ID = configuration.measurementId
  const PROJECT_ID = configuration.projectId
  const SENTRY_DSN = configuration.dashboardSentryUrl
  const CLOUDINARY_UPLOAD_URL = configuration.cloudinaryUploadUrl
  const CLOUDINARY_FOOD = configuration.cloudinaryApiKey
  const VAPID_KEY =
    'BOpVOtmawD0hzOR0F5NQTz_7oTlNVwgKX_EgElDnFuILsaE_jWYPIExAMIIGS-nYmy1lhf2QWFHQnDEFWNG_Z5w'
  const PAID_VERSION = configuration.isPaidVersion

  return {
    GOOGLE_MAPS_KEY,
    FIREBASE_KEY,
    APP_ID,
    AUTH_DOMAIN,
    STORAGE_BUCKET,
    MSG_SENDER_ID,
    MEASUREMENT_ID,
    PROJECT_ID,
    SERVER_URL,
    WS_SERVER_URL,
    SENTRY_DSN,
    CLOUDINARY_UPLOAD_URL,
    CLOUDINARY_FOOD,
    VAPID_KEY,
    PAID_VERSION
  }
}

export default ConfigurableValues
